import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { useMeilisearch } from 'src/hooks/meilisearch/use-meilisearch';
import { useUserStore } from 'src/store/user-store';
import { fetchEmployees } from '../lib/employees';
import { employeesKeys } from '../query-keys/employees';

export const useEmployeesByTokens = (tokens: string[]) => {
  const { directoryToken } = useUserStore();

  const searchState: SearchState = {
    filter: [tokens.map(token => `token = ${token}`) ?? []],
    q: '',
    sort: [],
  };

  const query = useMeilisearch({
    fetch: fetchEmployees,
    queryKey: employeesKeys.list(
      directoryToken!,
      tokens.length ?? 0,
      0,
      searchState,
    ),
    page: 1,
    perPage: tokens.length ?? 0,
    searchState,
    enabled: tokens.length > 0,
  });

  return query;
};
